<template>
  <span
    class="cs-text"
    :class="{ 'cs-text-tooltip': showOverflowTooltip }"
    v-if="!editVisible"
  >
    <span v-tooltip="$slots.default" class="cs-text-content">
      <slot></slot>
    </span>
    <el-tooltip
      v-if="copy"
      effect="light"
      :value="tipVisible"
      :manual="true"
      placement="right"
      ref="copy"
    >
      <div slot="content" class="copy-tip">{{ tip }}</div>
      <i
        @click="onCopy"
        @mouseenter="onMouseenter"
        @mouseleave="onMouseleave"
        class="el-icon-copy-document"
      />
    </el-tooltip>
    <el-tooltip v-if="edit" effect="light" content="编辑" placement="right">
      <i @click="onEdit" class="el-icon-edit-outline" />
    </el-tooltip>
  </span>
  <el-input
    v-else
    class="cs-text-input"
    ref="input"
    v-model="value"
    clearable
    size="mini"
    @keyup.enter.native="submit"
  />
</template>

<script>
import ClipboardJS from "clipboard";

export default {
  name: "CsText",
  props: {
    content: {
      type: [String, Number],
      required: false,
      default: undefined,
    },
    copy: {
      type: Boolean,
      required: false,
      default: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    showOverflowTooltip: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  model: {
    prop: "content",
    event: "update",
  },
  data() {
    return {
      tip: "复制",
      tipVisible: false,
      editVisible: false,
      value: "",
    };
  },
  methods: {
    onCopy(event) {
      const clipboard = new ClipboardJS(event.target, {
        text: () => {
          return this.content === undefined ? this.$el.innerText : this.content;
        },
      });
      clipboard.on("success", (e) => {
        this.tip = "复制成功!";
        this.$nextTick(() => {
          this.$refs.copy.updatePopper();
        });
        e.clearSelection();
        clipboard.destroy();
      });

      clipboard.on("error", () => {
        this.tip = "复制失败!";
        this.$nextTick(() => {
          this.$refs.copy.updatePopper();
        });
        clipboard.destroy();
      });

      clipboard.onClick(event);
    },
    onMouseenter() {
      this.tip = "复制";
      this.tipVisible = true;
    },
    onMouseleave() {
      this.tipVisible = false;
    },
    onEdit() {
      this.editVisible = true;
      this.value =
        this.content === undefined ? this.$el.innerText : this.content;
      this.$nextTick(function () {
        this.$refs.input.focus();
        window.addEventListener("click", this.hide, true);
      });
    },
    hide(event) {
      if (!this.$el.contains(event.srcElement)) {
        this.submit();
      }
    },
    submit() {
      if (this.value !== this.content) {
        this.$emit("update", this.value);
      }
      this.editVisible = false;
      this.value = "";
      window.removeEventListener("click", this.hide, true);
    },
  },
};
</script>
<style lang="scss" scoped>
.cs-text {
  .el-icon-copy-document {
    margin-left: 3px;
    cursor: copy;
    &:hover {
      color: #409eff;
    }
  }
  .el-icon-edit-outline {
    margin-left: 3px;
    cursor: pointer;
    &:hover {
      color: #409eff;
    }
  }
}
.cs-text-tooltip {
  display: inline-flex;
  width: 100%;
  align-items: center;
  .cs-text-content {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.cs-text-input {
  min-width: 150px;
  display: inline-block;
}
.copy-tip {
  pointer-events: none;
  white-space: nowrap;
}
</style>
